/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// project imports
import { ForgotPassword, NotFound, VerifyEmail, AdminLogin } from 'features/components';
import  AppLayoutNew  from 'features/components/base/layouts/AppLayout';
import { isAuthenticated, isAuthorized } from 'shared/settings/auth';

// style imports
// import 'react-toastify/dist/ReactToastify.css';
import { CategoryService, ItemsService } from 'shared/services';
import store from 'features/store';
import pmservice from 'shared/services/pmservice';
import { BreadcrumbsManager } from 'shared/hoc/breadcrumbs/Breadcrumbs';
//import LogRocket from 'logrocket';
//import { logRocketDevId } from 'shared/settings/config';
// import store from 'features/store';

/**
 * routing for all features components
 * 
 * @param props
 * 
 * @return routing for all features components
 * 
**/

const RouterChange = (props) => {

    useEffect(() => {
        store.dispatch({ type: 'ROUTE_CHANGE', payload: props.location.pathname });
    }, [props.location.pathname]);

    return null;
};

export class FeaturesRouter extends Component {

    constructor(props) {
        super(props);

        this.state = {
            page: false
        };
    }
    componentDidMount() {
        // if (isAuthorized()) {
        //     let userdetails = store.getState().user;
        //     LogRocket.init(logRocketDevId);
        //     LogRocket.identify(userdetails.id.toString(), {
        //         name: `${userdetails.lastName}, ${userdetails.firstName}`,
        //         email: userdetails.email,

        //         // Add your own custom user variables here, ie:
        //         subscriptionType: 'pro'
        //     });
        //     LogRocket.getSessionURL(sessionURL => {
        //         console.table("water bottle", sessionURL);
        //     });
        // }
        // isAuthenticated(this.props.history)
        //     .then(res => {
        //         this.setState({ page: true }, () => {
        //             const data = {
        //                 "filter": [
        //                     { "field": "status", "value": "Active", "op": "=", "join": "AND" },
        //                     { "field": "advertisetype", "value": "Banner", "op": "=", "join": "AND" }
        //                 ]
        //             };
        //             SalesService.getAdvList(data).then( response => {
        //                 let advData = response.data.data;
        //                 advData.map((data, index) => {
        //                     if (data.advertisetype == "Banner") {
        //                         store.dispatch({ type: 'PREMIER_BANNER_IMAGE', payload: { bannerData: data} });
        //                     }
        //                 })
        //             }).catch((error) => {
                       
        //             });
                    
        //         });
        //     });
        // this.preloadAssets();
        this.getPageLoadApis();
    }

    // preloadAssets = () => {
    //     // 👇 Preload the image immediately
    //     const link = document.createElement('link');
    //     link.rel = 'preload';
    //     link.as = 'image';
    //     link.href = homeBg;
    //     link.fetchPriority = 'high';
    //     document.head.appendChild(link);
    // };

    getPageLoadApis = () => {
        Promise.all([isAuthenticated(this.props.history), CategoryService.getCategorySelectionList(), pmservice.getMultipleContent(['homebanner', 'privacy-policy']), this.getFeaturedItem()]).then((responses) => {

            store.dispatch(({ type: 'CATEGORY', payload: this.formatCategorySelectionData(responses[1].data.data.data) }));
            
            let bannerContent = {};
            if ( Array.isArray(responses[2]?.data?.data) ) {

                const contentList = responses[2]?.data?.data;

                const bannerData = contentList.find(elem => elem.screenname === 'homebanner');
                const privacyPolicyData = contentList.find(elem => elem.screenname === 'privacy-policy');

                if ( bannerData ) {
                    bannerContent = JSON.parse(bannerData.jsoncontent);

                    // 👇 Preload the image immediately
                    const link = document.createElement('link');
                    link.rel = 'preload';
                    link.as = 'image';
                    link.href = bannerContent.bgimage;
                    link.fetchPriority = 'high';
                    document.head.appendChild(link);

                    store.dispatch(({ type: 'HOMEBANNER', payload: bannerContent }));
                }

                if ( privacyPolicyData ) {
                    store.dispatch(({ type: 'PRIVACY_POLICY', payload: JSON.parse(bannerData.jsoncontent) }));                    
                }
            }

            store.dispatch(({ type: 'MULTI_LIST', payload: responses[3]}));
            this.setState({ page: true });
        }).catch(error => {
        });
    }

     getFeaturedItem = () => {
        const payload = {
            "sort": [{ "field": "id", "direction": "asc" }],
            "field": ["itemid", "title", "itemdisplayurl", "itemtypeid", "status","saleid","itemseourl"],
        };
        return new Promise((resolve, reject) => {
            ItemsService.getshopwithItemList(payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    }
    formatCategorySelectionData = (categorySelectionData) => {
        let categoryList = [];
        categorySelectionData.forEach((element, index) => {
            const parentId = (index + 1).toString();
            const category = { id: parentId, label: element.category, type: 'category', subCategory: [], active: false };
            element.selection.forEach((subElement, index) => {
                category.subCategory.push({ id: parentId + (index + 1), label: subElement.subcategory, type: 'subcategory', active: false });
            });

            categoryList.push(category);
        });

        return categoryList;
    };

    render() {
        return (this.state.page ?
            <>
                <RouterChange {...this.props} />
                <BreadcrumbsManager {...this.props} />
                <Switch>
                    <Route exact path="/admin">
                        {
                            isAuthorized() ? <Redirect to="/" /> : <AdminLogin {...this.props} />
                        }
                    </Route>
                    <Route exact path="/forgot-password">
                        {
                            isAuthorized() ? <Redirect to="/" /> : <ForgotPassword {...this.props} />
                        }
                    </Route>
                    {/* <Route exact path="/set-password">
                        {
                            isAuthorized() ? <Redirect to="/" /> :  <Register {...this.props} />
                        }
                    </Route> */}
                    <Route exact path="/verify-email">
                        {
                            () => {
                                return isAuthorized(true) ? <Redirect to="/" /> : <VerifyEmail {...this.props} />
                            }
                        }
                    </Route>
                    <Route>
                        {
                            <AppLayoutNew {...this.props} />
                        }
                    </Route>
                    <Route exact path="/not-found" component={NotFound} />

                    <Redirect to="/" />
                </Switch>
            </> :
            <div className="pre-loader">
                <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="pre-loader-image" alt="loader-icon"></img>
            </div>
        );
    }
}
